import React  from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useEffect } from 'react';
import { useRecoilCallback, useRecoilState } from 'recoil';
import { valuesFormRegisterState } from 'src/Patient/state/atoms';
import InputLabelCustom from 'src/shared/components/forms/InputLabelCustom';
import { finderGeneroByName } from 'src/shared/global/helpers';
import useCatchErrorApi from 'src/shared/hooks/useCatchErrorApi';
import { userState } from 'src/store/user/userState';
import { generosBaseFetchState, generosBaseState } from '../register/state/atoms';

const GeneroAutocomplete = () => {
    const { catchErrorApi } = useCatchErrorApi();
    const [{ idgDescrip }, setValuesFormRegister] = useRecoilState(valuesFormRegisterState);
    const [generosBase, setGenerosBase] = useRecoilState(generosBaseState);
    const [user, setUser] = useRecoilState(userState);

    const loadGenerosBase = useRecoilCallback(({ snapshot }) => async () => {
        //setLoading(true)
        try {
            const generrosFetch = await snapshot.getPromise(generosBaseFetchState);
            setGenerosBase(generrosFetch)

        } catch (error) {
            catchErrorApi(error);
        } finally {
            //setLoading(false)
        }
    }, []);

    useEffect(() => {
        loadGenerosBase()
    }, [loadGenerosBase])

    return (
        <>
            <InputLabelCustom htmlFor="autocomplete-genero" text="Género (Opcional)" />
            <Autocomplete
                size="small"
                id="autocomplete-genero"
                options={generosBase.map((option) => `${option.idgDescrip}`)}
                getOptionLabel={option => option || null}
                value={idgDescrip || generosBase.find(x => x.idgGenero === user?.payload?.idgGenero)?.idgDescrip || null}
                noOptionsText="Sin resultados"
                onChange={(event, newInputValue, reason) => {

                    if (reason === 'clear') {
                        setValuesFormRegister((currentState) => ({
                            ...currentState,
                            idgGenero: null,
                            idgDescrip: null
                        }))   

                        if(user.payload) {
                            setUser({
                                ...user,
                                payload: {
                                    ...user.payload,
                                    idgGenero: null
                                }
                            })
                        }

                        return;
                    }

                    if (reason === 'selectOption') {
                        const finderGenero = finderGeneroByName(generosBase, newInputValue);
                        setValuesFormRegister((currentState) => ({
                            ...currentState,
                            idgGenero: finderGenero.idgGenero,
                            idgDescrip: newInputValue
                        }))                        
                    }
                }}
                renderInput={(params) => <TextField {...params} placeholder="Seleccione género" variant="outlined" />}
            />
        </>
    )
}

export default GeneroAutocomplete;